import Image from 'next/image';

import { Container, Title, InfoText, BarCode } from './payment-card.elements';

import paymentQrCode from '@/assets/img/payment-qr-code.png';

import { companyInfo } from '@/data/company-info.data';

const PaymentCard = () => (
  <Container>
    <Title>Plaćanje</Title>
    <InfoText $caps $colored $centered>
      Inkubator izvrsnosti
    </InfoText>
    <InfoText>
      <p>Adresa: {companyInfo.address}</p>
      <p>OIB: {companyInfo.pin}</p>
    </InfoText>

    <InfoText $colored>Plaćanje možeš izvršiti na račun:</InfoText>
    <InfoText>IBAN: {companyInfo.iban}</InfoText>

    <InfoText $colored>Ili skeniraj barkod i unesi iznos:</InfoText>
    <BarCode>
      <Image
        src={paymentQrCode}
        alt="QR code"
        style={{ objectFit: 'cover', maxWidth: '100%', height: 'auto' }}
      />
    </BarCode>
  </Container>
);

export { PaymentCard };
